import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import type { FC } from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyM } from 'components/basic/Typography';

import { useAppDispatch, useAppSelector } from 'redux-store';
import { setTopBannerShowed } from 'redux-store/slices/ui';

import styles from './TopBanner.module.scss';

const promos = [
  {
    start: new Date(2024, 0, 18, 0, 0, 0),
    end: new Date(2024, 0, 21, 23, 59, 59),
    text: 'Special offer through January 21',
    discount: 35,
    link: 'https://app.welltory.com/payments/plans/premium-features/?coupon=prm_jan3_2024web',
    image: '/pagesImages/landing/main/top-banner-dec28.png',
    imageMobile: '/pagesImages/landing/main/top-banner-dec28-mobile.png'
  }
];

const TopBanner: FC<{ hide?: boolean }> = ({ hide }) => {
  const isTopBannerShowed = useAppSelector(state => state.ui.isTopBannerShowed);
  const dispatch = useAppDispatch();
  const [isRender, setIsRender] = useState(false);
  const { userAgent } = useAppSelector(state => state.ui);
  const isMobile = userAgent.device.type === 'mobile';

  useEffect(() => {
    if (hide) {
      return;
    }

    setIsRender(true);
  }, []);

  if (!isRender) {
    // для того, чтобы компонент отрисовывался только на клиенте, в противном случае, будет ошибка с hydrate
    return null;
  }

  const currentPromo = promos.find(item => {
    const now = new Date().getTime();

    if (now >= item.start.getTime() && item.end.getTime() >= now) {
      return item;
    }

    return null;
  });

  if (!currentPromo) {
    return null;
  }

  function closeBanner(e: React.BaseSyntheticEvent): void {
    e.stopPropagation();
    e.preventDefault();
    Cookies.set('isTopBannerShowed', 'false');
    dispatch(setTopBannerShowed({ isTopBannerShowed: false }));
  }

  if (isTopBannerShowed === false) {
    return null;
  }

  let currentPromoImageSrc = currentPromo.image;
  if (isMobile) {
    currentPromoImageSrc = currentPromo.imageMobile;
  }

  return (
    <a
      className={styles.topBannerWrapper}
      href={currentPromo.link}
      onClick={(): void => {
        logEvent('Web_Top_Banner_Button_Clicked');
      }}
    >
      <img
        src={currentPromoImageSrc}
        className={cn(styles.imgBlurred, { [styles.isMobile]: isMobile })}
      />
      <div className={styles.topBannerTextWrapper}>
        <BodyM className={cn(styles.text)}>{currentPromo.text}</BodyM>
        <div className={styles.link}>
          <BodyM className={styles.text}>Save {currentPromo.discount}%</BodyM>
          <Icon icon={IconTypes.arrowRight} color="fon_1" />
        </div>
      </div>
      <Icon
        icon={IconTypes.close}
        color="fon_1"
        className={styles.icon}
        onClick={(e): void => {
          closeBanner(e);
          logEvent('Web_Top_Banner_Close_Button_Clicked');
        }}
      />
    </a>
  );
};

export default TopBanner;
